import { Box, H5, Stack, Text } from "@adfenix/alexandria";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const IconWithMargin = styled.i`
  margin-right: 4px;
  margin-left: 0;
  padding-left: 0;
  color: ${({ theme }) => theme.colors.primary};
`;

const Li = styled.li`
  list-style-type: disc;
  color: ${({ theme }) => theme.colors.black};
`;

const NotSeeingTheRightPagesInfo = () => {
  const { t } = useTranslation();
  return (
    <Stack spacing="xs2" style={{ marginBottom: 24 }}>
      <Box display="flex">
        <IconWithMargin
          color="primary"
          className="uil uil-question-circle is-size-4"
        />
        <H5 style={{ marginTop: 4 }}>{t("selfonboarding.notSeeing.header")}</H5>
      </Box>

      <Text style={{ paddingLeft: 38 }}>
        {t("selfonboarding.notSeeing.description")}
      </Text>
      <ul style={{ paddingLeft: 64 }}>
        <Li>{t("selfonboarding.notSeeing.bullet1")}</Li>
        <Li>{t("selfonboarding.notSeeing.bullet2")}</Li>
        <Li>{t("selfonboarding.notSeeing.bullet3")}</Li>
      </ul>
    </Stack>
  );
};

export default NotSeeingTheRightPagesInfo;
